export default {
  computed: {
    analitik() {
      let temp = [];
      temp = [
        {
          icon: 'mdi-account-alert',
          color: 'grey',
          label: 'Belum Dinilai',
          value: this.$getDeepObj(this, 'stats.belum_dinilai') || 0,
          key: 3,
          grid: { cols: 12, md: 3, sm: 12 },
        },
        {
          icon: 'mdi-account-check',
          color: 'success',
          label: 'Sudah Dinilai',
          value: this.$getDeepObj(this, 'stats.sudah_dinilai') || 0,
          key: 2,
          grid: { cols: 12, md: 3, sm: 12 },
        },
        {
          icon: 'mdi-account-remove',
          color: 'orange',
          label: 'Terkendala <br/>(Penjadwalan Ulang)',
          value: this.$getDeepObj(this, 'stats.kendala') || 0,
          key: 4,
          grid: { cols: 12, md: 3, sm: 12 },
        },
        {
          icon: 'mdi-account-remove',
          color: 'red',
          label: 'Terkendala <br/>(Diskualifikasi)',
          value: this.$getDeepObj(this, 'stats.diskualifikasi') || 0,
          key: 5,
          grid: { cols: 12, md: 3, sm: 12 },
        },
      ];

      return temp;
    },

    akunId() {
      return this.$getDeepObj(this.akun, 'akun_id') || '0';
    },

    tglTutup() {
      return this.$getDeepObj(this, 'configSlot.tgl_tutup') || '';
    },

    tglBuka() {
      return this.$getDeepObj(this, 'configSlot.tgl_buka') || '';
    },

    tglTutupJadwal() {
      return this.$getDeepObj(this, 'configSlot.tgl_selesai_jadwal') || '';
    },

    tglBukaJadwal() {
      return this.$getDeepObj(this, 'configSlot.tgl_mulai_jadwal') || '';
    },

    isTutup() {
      const now = new Date(this.wktOnline);
      const tutup = new Date(this.tglTutupJadwal);

      return now > tutup;
    },

    isTutupPenilaian() {
      const now = new Date(this.wktOnline);
      const tutup = new Date(this.tglTutup);

      return now > tutup;
    },

    masterConfigSlot() {
      let slot = [];
      let obj = this.$getDeepObj(this, 'configSlot.slot-ke') || [];

      for (let i in obj) {
        slot.push({ value: i.toString(), text: obj[i] });
      }

      return slot;
    },

    filterMaster() {
      let temp = [
        { value: '3', text: 'Belum Dinilai' },
        { value: '5', text: 'Sudah Dinilai' },
        { value: '6', text: 'Sudah Dikonfirmasi' },
        { value: '0', text: 'Terkendala( Diskualifikasi )' },
        { value: '1', text: 'Terkendala( Penjadwalan Kembali )' },
      ];

      return temp;
    },

    filterMasterKategori() {
      return [
        { value: '1', text: 'Kategori A' },
        { value: '2', text: 'Kategori B' },
        { value: '3', text: 'Kategori C' },
      ];
    },

    kategoris() {
      return {
        1: { text: 'A', color: 'success' },
        2: { text: 'B', color: 'orange' },
        3: { text: 'C', color: 'red' },
      };
    },

    formFilter() {
      let temp = [];
      if (this.isAsesor) {
        temp = [
          {
            label: 'Tanggal',
            default: true,
            type: 'date',
            outlined: true,
            dense: true,
            model: 'tgl_simulasi',
          },
          {
            label: 'Sesi / Slot',
            default: true,
            type: 'select',
            model: 'slot',
            props: ['attach'],
            master: this.masterConfigSlot,
          },
          {
            label: 'Status',
            default: true,
            type: 'select',
            model: 'k_proses_simulasi_psp',
            props: ['attach'],
            master: this.filterMaster,
          },
        ];
      } else {
        temp = [
          {
            label: 'Tanggal',
            default: true,
            type: 'date',
            outlined: true,
            dense: true,
            model: 'tgl_simulasi',
            grid: { cols: 12, md: 6, sm: 12 },
          },
          {
            label: 'Sesi / Slot',
            default: true,
            type: 'select',
            model: 'slot',
            props: ['attach'],
            master: this.masterConfigSlot,
            grid: { cols: 12, md: 6, sm: 12 },
          },
          // {
          //   label: 'Kategori Nilai',
          //   default: true,
          //   type: 'select',
          //   model: 'kategori',
          //   props: ['attach'],
          //   master: this.filterMasterKategori,
          //   grid: { cols: 12, md: 6, sm: 12 },
          // },
          {
            label: 'Status',
            default: true,
            type: 'select',
            model: 'k_proses_simulasi_psp',
            props: ['attach'],
            master: this.filterMaster,
            grid: { cols: 12, md: 6, sm: 12 },
          },
        ];
        temp.push({
          label: 'Pilih Asesor',
          // default: true,
          type: 'select',
          model: 'akun_id',
          props: ['attach'],
          master: this.asesors,
          grid: { cols: 12, md: 6, sm: 12 },
        });
        temp.push({
          label: 'Status GMeet',
          default: true,
          type: 'checkbox',
          model: 'is_rekaman',
          master: [{ value: '0', text: 'Lihat Status Sesi Kandidat yang Belum menyertakan Tautan GMeet' }],
          grid: { cols: 12, md: 12, sm: 12 },
        });
      }

      return temp;
    },

    filtered() {
      const filters = this.filters || {};
      let label = [];
      if (Object.keys(filters).length) {
        if (filters.tgl_simulasi) {
          label.push(this.$localDate(filters.tgl_simulasi));
        }

        if (filters && filters.k_proses_simulasi_psp && Number(filters.k_proses_simulasi_psp) >= 3) {
          label.push(this.filterMaster.find((s) => Number(s.value) === Number(filters.k_proses_simulasi_psp))['text']);
        }

        if (filters.slot) {
          label.push(this.$getDeepObj(this, `configSlot.slot-ke.${filters.slot}`));
        }

        if (filters && filters.kategori && filters.kategori.length) {
          if (Number(filters.kategori) === 0) {
            label.push('Perlu Integrasi');
          } else {
            label.push(this.filterMasterKategori.find((s) => Number(s.value) === Number(filters.kategori))['text']);
          }
        }

        if (filters && Number(filters.is_rekaman) === 0) {
          label.push('Belum menyertakan Tautan GMeet');
        }

        if (filters && filters.akun_id) {
          label.push(this.asesors.find((s) => s.value === filters.akun_id)['text']);
        }

        if (filters && filters.is_kendala && Number(filters.is_kendala) === 1) {
          label.push(Number(filters.is_ulang) === 1 ? 'Penjadwalan Kembali' : 'Diskualifikasi');
        }

        // if (filters && filters.akun_id) {
        //   label.push(this.pemantaus.find((s) => s.value === filters.akun_id)['text']);
        // }
      }

      return label || [];
    },

    isGelombangAktif() {
      return Number(this.params.gelombang) === 2;
    },

    masterAsesor() {
      return this.$getDeepObj(this, 'configSlot.pemantau') || {};
    },

    isAsesorA() {
      return this.configSlot && this.configSlot.is_penjadwal === 1;
    },

    infoAsesors() {
      let temp = [];

      temp.push({
        title: 'Tim Pemantau',
        nama: this.$getDeepObj(this, 'masterAsesor.nama') || '-',
        no_telpon: this.$getDeepObj(this, 'masterAsesor.no_telpon'),
        no_hp: this.$getDeepObj(this, 'masterAsesor.no_hp'),
      });

      const pasangans = this.$getDeepObj(this, 'configSlot.pasangans') || [];
      if (pasangans.length) {
        pasangans.forEach((item) => {
          temp.push({
            title: 'Pasangan Asesor',
            nama: this.$getDeepObj(item, 'nama'),
            no_telpon: '',
            no_hp: this.$getDeepObj(item, 'no_hp'),
          });
        });
      }

      return temp;
    },

    isPusat() {
      return !!this.groups[120];
    },

    isLaporanKinerja() {
      let status = false;
      status = Number(this.stats && this.stats.belum_dinilai) === 0;

      return this.isTutupPenilaian ? false : !status;
    },
  },

  methods: {
    aksiBtn(item) {
      const isAsesorUtama = this.isUtama(item);
      const isKonfirmasi = Number(item.k_proses_simulasi_psp) === 6;
      const isLengkap = isAsesorUtama ? Number(item.k_proses_simulasi_psp) >= 5 : isKonfirmasi;
      const isTerkendala = this.isTerkendala(item);

      const color = isTerkendala ? 'primary' : isLengkap ? 'primary' : 'success';
      const label = isTerkendala ? 'Ubah Nilai' : isLengkap ? 'Ubah Nilai' : 'Mulai & Nilai';

      return { color, label };
    },

    getDurasi(item) {
      const tanggal = this.$getDeepObj(item, 'tgl_simulasi').split(' ')[0];
      let start = new Date(this.wktOnline);
      let end = new Date(tanggal + ' ' + this.$getDeepObj(item, 'jam_mulai'));
      let diff = end - start;
      let days = Math.floor(diff / 86400000);
      let hours = parseInt((Math.abs(start - end) / (1000 * 60 * 60)) % 24);
      // let minutes = parseInt((Math.abs(start.getTime() - end.getTime()) / (1000 * 60)) % 60)
      return `${days ? days + ' hari' : ''} ${hours ? hours + ' jam' : ''}`;
    },

    isMulaiWawancara(item) {
      const tanggal = this.$getDeepObj(item, 'tgl_simulasi').split(' ')[0];
      const now = new Date(this.wktOnline);
      const date = new Date(tanggal + ' ' + this.$getDeepObj(item, 'jam_mulai'));
      return now > date;
    },

    filterStatus(filters) {
      // Filter url rekaman
      let objFilter = Object.assign({}, filters);
      if (filters.is_rekaman && filters.is_rekaman[0]) this.$set(objFilter, 'is_rekaman', 0);
      else this.$delete(objFilter, 'is_rekaman');

      // Filter kategori
      if (![undefined, '', null].includes(filters.k_proses_simulasi_psp)) {
        if (['0', '1'].includes(filters.k_proses_simulasi_psp)) {
          this.$set(objFilter, 'is_kendala', 1);
          this.$set(objFilter, 'is_ulang', filters.k_proses_simulasi_psp || 0);
          this.$delete(objFilter, 'k_proses_simulasi_psp');
        } else if (['3', '5', '6'].includes(filters.k_proses_simulasi_psp)) {
          this.$set(objFilter, 'is_kendala', 0);
          this.$set(objFilter, 'k_proses_simulasi_psp', filters.k_proses_simulasi_psp);
          this.$delete(objFilter, 'is_ulang');
        } else {
          this.$delete(objFilter, 'is_kendala', 1);
          this.$delete(objFilter, 'is_ulang');
          this.$delete(objFilter, 'k_proses_simulasi_psp');
        }
      }

      // set filter
      this.filters = objFilter;
      Object.assign(this.params, { page: 1 });
      this.fetchData();
      this.$refs.filter.close();
    },

    isIntegrasi(item) {
      const penilaians = (item && item.gpm_penilaians) || [];
      const asesor1 = penilaians && penilaians[0] && penilaians[0]['kategori'];
      const asesor2 = penilaians && penilaians[1] && penilaians[1]['kategori'];

      return asesor1 !== asesor2;
    },

    isLengkap(item) {
      const penilaians = (item && item.gpm_penilaians) || [];
      let status = false;
      if (this.params.angkatan === 1) {
        const asesor1 = (penilaians && penilaians[0] && penilaians[0]['is_lengkap']) || 0;
        const asesor2 = (penilaians && penilaians[1] && penilaians[1]['is_lengkap']) || 0;
        status = asesor1 === 1 && asesor2 === 1;
      } else {
        status =
          penilaians &&
          penilaians[0] &&
          penilaians[0]['is_lengkap'] === 1 &&
          penilaians &&
          penilaians[0] &&
          penilaians[0]['is_konfirmasi'] !== null;
      }

      return status;
    },

    statustNilai(item) {
      const isAsesorUtama = this.isUtama(item);
      const isKonfirmasi = Number(item.k_proses_simulasi_psp) === 6;
      const isLengkap = isAsesorUtama ? Number(item.k_proses_simulasi_psp) >= 5 : isKonfirmasi;
      const isTerkendala = this.isTerkendala(item);

      let status = {};
      if (this.isAsesor) {
        status = {
          color: isTerkendala ? 'orange' : isLengkap ? 'success' : 'grey',
          text: isTerkendala ? 'Terkendala' : isLengkap ? 'Sudah' : 'Belum',
        };
      } else {
        status = {
          color: isTerkendala ? 'orange' : isLengkap && isKonfirmasi ? 'success' : 'grey',
          text: isTerkendala ? 'Terkendala' : isLengkap && isKonfirmasi ? 'Sudah' : 'Belum',
        };
      }

      return status;
    },

    statusSusulan(item) {
      const pspSimulasi = this.$getDeepObj(item, 'psp_simulasis.data.0') || {};
      const susulan = pspSimulasi?.is_ulang ?? 0;
      return {
        color: susulan === 1 ? 'orange' : 'red',
        text: susulan === 1 ? 'Penjadwalan Kembali' : 'Diskualifikasi',
      };
    },

    onCall(item) {
      const url = `https://wa.me/62${Number(item)}`;
      window.open(url, '_blank');
    },

    onAngkatan(value) {
      if (value === 2) {
        this.$delete(this.params, 'is_susulan');
        this.$delete(this.params, 'susulan_ke');
      }

      this.onReload();
    },

    fetchStatistik() {
      if (!this.$allow(`psp-${this.api}-simulasi-ajar.statistik`)) return;
      const payload = {
        api: this.api,
        params: {
          gelombang: this.params.gelombang,
        },
      };
      this.getStatistik(payload);
    },

    isKonfirmasiAsesor(item) {
      return item && item.k_proses_simulasi_psp === 6;
    },

    onChangeFilter(value) {
      if (!this.$allow(`psp-${this.api}-asesor.index-nilai`)) {
        return;
      }

      this.fetchAsesor({ asesor_id: value.akun_id }, 'asesors');
    },

    fetchAsesor(params = {}, type = '') {
      if (this.isAsesor) {
        return;
      }

      this.getAsesor({ params, api: this.api }).then((resp) => {
        const data = [...resp];

        this[type] = data.map((key) => {
          return {
            value: this.$getDeepObj(key, 'akun.data.akun_id'),
            text: this.$getDeepObj(key, 'akun.data.nama'),
          };
        });
      });
    },

    onDownloadKinerja() {
      const payload = {
        k_fungsi_gpm: this.mFungsi[this.fungsi],
        angkatan: this.params.angkatan,
        api: this.api,
      };

      this.getKinerja(payload).then((url) => {
        window.open(url, '_blank');
      });
    },

    async onKinerja() {
      let statistik = { ...this.stats };
      const params = {
        tipe: this.fungsi,
        angkatan: 2,
        count: 100,
        api: this.api,
      };

      const resp = await this.fetch({ params, api: this.api || '' });
      const data = (resp && resp.data) || [];
      const items = [];
      let index = 1;
      let diskualifikasi = 0;

      data.forEach((item) => {
        const isAsesorUtama = this.isUtama(item);
        const isDiskualifikasi = this.isTerkendala(item)
          ? item && item[this.gpm] && item[this.gpm].is_rekomendasi_susulan === 0
          : true;
        const status = isAsesorUtama
          ? item && item.gpm_penilaians && item.gpm_penilaians[0] && item.gpm_penilaians[0]['is_lengkap'] === 1
          : item && item.gpm_penilaians && item.gpm_penilaians[0] && item.gpm_penilaians[0]['is_konfirmasi'] !== null;

        if (this.isTerkendala(item) && isDiskualifikasi) {
          diskualifikasi++;
        }

        if (this.isTerkendala(item) ? isDiskualifikasi : status) {
          items.push({
            no: index,
            kandidat: `${this.$getDeepObj(item, 'gpm_guru.ptk.nama') || '-'}`,
            status: this.isTerkendala(item)
              ? 'Terkendala (Diskualifikasi)'
              : status
              ? 'Sudah Dinilai'
              : 'Belum Dinilai',
            wkt_nilai: this.$localDate(this.$getDeepObj(item, 'gpm_penilaians.0.wkt_nilai') || '-') || '-',
          });
          index++;
        }
      });

      this.$set(statistik, 'kandidat', Number(statistik.sudah_dinilai) + diskualifikasi);
      this.$set(statistik, 'diskualifikasi', diskualifikasi);

      this.$refs.kinerja.open();

      this.$nextTick(() => {
        this.$refs.formkinerja.reset();
        this.$refs.formkinerja.data = [];
        this.$refs.formkinerja.items = items;
        this.$refs.formkinerja.statistik = statistik;
        this.$refs.formkinerja.tanggal = this.$durasi(this.tglBuka, this.tglTutup);
      });
    },
  },
};
